export const isNonEmptyString = (value: unknown): value is string => {
  const text = String(value)
  return text === value && text.trim().length > 0
}
